import React, { useEffect, useState } from "react"
import { Item, Modal, Button } from "semantic-ui-react"

import { CyclistOwned, YGRPartner, LeagueOfCyclists } from "./Badges"

export const CompanyModal = ({ company, onCloseCallback }) => {
  const [isOpen, setIsOpen] = useState()

  useEffect(() => {
    setIsOpen(true)
  }, [company])

  const onClose = () => {
    setIsOpen(false)
    onCloseCallback()
  }

  const CompanyAttribute = ({ label, attribute }) => {
    let attr = company[attribute]

    if (!attr) {
      return null
    }

    if (attr.startsWith("http")) {
      attr = (
        <a href={attr} target="_blank" rel="noopener noreferrer">
          {attr}
        </a>
      )
    }

    return (
      attr && (
        <>
          <Item.Header>{label}</Item.Header>
          <Item.Description>{attr}</Item.Description>
          <Item.Extra>
            <br />
          </Item.Extra>
        </>
      )
    )
  }

  const logo = company.logo_url || "https://react.semantic-ui.com/images/wireframe/image.png"

  return (
    <Modal dimmer={"blurring"} open={isOpen} onClose={onClose}>
      <Modal.Header as="h1">{company.name}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Item.Group>
            <Item>
              <Item.Image size="small" src={logo} />

              <Item.Content>
                <CompanyAttribute label="Business type" attribute="biz_type" />
                <CompanyAttribute label="What they need" attribute="needs" />
                <CompanyAttribute label="Owner" attribute="owner_name" />
                <CompanyAttribute
                  label="Contributions to the cycling community"
                  attribute="contributions"
                />
                <CompanyAttribute label="Contact" attribute="contact_name" />
                <CompanyAttribute label="Email" attribute="contact_email" />
                <CompanyAttribute label="Website" attribute="website" />
                <CompanyAttribute label="Facebook" attribute="facebook" />
                <CompanyAttribute label="Instagram" attribute="instagram" />
                <CompanyAttribute label="Twitter" attribute="twitter" />
                <Item.Extra>
                  <CyclistOwned company={company}></CyclistOwned>
                  <YGRPartner company={company}></YGRPartner>
                  <LeagueOfCyclists company={company}></LeagueOfCyclists>
                </Item.Extra>
              </Item.Content>
            </Item>
          </Item.Group>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button icon="close" labelPosition="right" content="Close" onClick={onClose} />
      </Modal.Actions>
    </Modal>
  )
}
